import {
  PENDING,
  WAGERING,
  COLLECTING,
  CASHBACK_BONUS_TYPE,
  DEPOSIT_TRIGGER_TYPE,
  FREE_SPINS_BONUS_TYPE,
  FREE_SPINS_FOR_DEPOSIT_TRIGGER_TYPE,
  WAGERING_BONUS_MECHANIC,
  FREE_SPINS_BONUS_MECHANIC,
  DEPOSIT_BONUS_TYPE,
} from '../../../constants/bonuses';

export const wageringBonusSelector = (data = []) => {
  return data.find(
    (bonus) =>
      !bonus.isCampaign &&
      [PENDING, WAGERING].includes(bonus.status) &&
      bonus.mechanicType === WAGERING_BONUS_MECHANIC
  );
};

export const collectingBonusSelector = (data = []) => {
  return data.find(
    (bonus) =>
      !bonus.isCampaign &&
      bonus.status === COLLECTING &&
      bonus.bonusType === CASHBACK_BONUS_TYPE &&
      bonus.mechanicType !== FREE_SPINS_BONUS_MECHANIC
  );
};

export const depositBonusSelector = (data = []) => {
  return data.find(
    (bonus) => !bonus.isCampaign && bonus.bonusType === DEPOSIT_BONUS_TYPE
  );
};

export const cashbackBonusSelector = (data = []) => {
  return data.find(
    (bonus) => !bonus.isCampaign && bonus.bonusType === CASHBACK_BONUS_TYPE
  );
};

export const freeSpinBonusSelector = (data = []) => {
  return data.find(
    (bonus) => !bonus.isCampaign && bonus.bonusType === FREE_SPINS_BONUS_TYPE
  );
};

export const activeFreeSpinCampaignSelector = (data = []) => {
  return data.find(
    (bonus) =>
      bonus.isCampaign &&
      bonus.status === PENDING &&
      bonus.campaignTriggerType === FREE_SPINS_FOR_DEPOSIT_TRIGGER_TYPE
  );
};

export const collectingCampaignIdSelector = (data = [], { isLoading }) => {
  const collectingBonus = collectingBonusSelector(data);
  const campaignId = collectingBonus?.campaignId;

  return {
    isLoading,
    campaignId,
  };
};

export const waitingDepositCampaignSelector = (data = []) => {
  return data.find(
    (bonus) =>
      bonus.isCampaign &&
      bonus.status === PENDING &&
      [DEPOSIT_TRIGGER_TYPE, FREE_SPINS_FOR_DEPOSIT_TRIGGER_TYPE].includes(
        bonus.campaignTriggerType
      )
  );
};
